import { render, staticRenderFns } from "./CampaignInfo.vue?vue&type=template&id=5333a90f&scoped=true&"
import script from "./CampaignInfo.vue?vue&type=script&lang=js&"
export * from "./CampaignInfo.vue?vue&type=script&lang=js&"
import style0 from "./CampaignInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CampaignInfo.vue?vue&type=style&index=1&id=5333a90f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5333a90f",
  null
  
)

export default component.exports